import { all } from "redux-saga/effects";
import { watchBookSaga } from "./bookSaga";
import { watchHasPaidSaga } from "./hasPaidSaga";
import { watchSentenceSaga } from "./sentenceSaga";
import { watchLanguageSaga } from "./langaugeSaga";

export default function* rootSaga() {
  yield all([
    watchLanguageSaga(),
    watchBookSaga(),
    watchSentenceSaga(),
    watchHasPaidSaga(),
  ]);
}
